<template>
  <div>
    <v-flex xs12 sm6 d-flex>
      <v-select
        :items="languages"
        :label="$vuetify.t('$vuetify.lobis.language')"
        item-text="value"
        item-value="key"
        v-model="language"
      ></v-select>
  </v-flex>
  <v-flex xs12>
    <v-btn @click="logout()">
      {{ $vuetify.t('$vuetify.lobis.logout') }}
    </v-btn>
  </v-flex>
  </div>
</template>

<script>
import { AUTH_LOGOUT } from '../../store/actions/auth'

export default {
  data: () => ({
    languages: []
  }),
  created () {
    this.languages = [...this.languages,
      {
        key: 'it',
        value: this.$vuetify.t('$vuetify.lobis.italian')
      },
      {
        key: 'de',
        value: this.$vuetify.t('$vuetify.lobis.german')
      }
    ]
  },
  computed: {
    language: {
      get () {
        return this.$store.state.user.settings.language
      },
      set (val) {
        this.$store.commit('CHANGE_LANGUAGE', val)
        this.$vuetify.lang.current = val
      }
    }
  },
  methods: {
    logout () {
      var r = confirm(this.$vuetify.t('$vuetify.lobis.logoutconfirmation'))
      if (r) {
        this.$store.dispatch(AUTH_LOGOUT)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings/Index.vue